import { useEffect, RefObject, useCallback } from 'react'

export const useClickAway = (
  state: string | boolean,
  ref: RefObject<HTMLElement>,
  awayCallback: (event: MouseEvent) => void
) => {
  const handleClickOutside = useCallback(
    (event: MouseEvent) => {
      const isTargetHasEvent =
        ref.current && ref.current.contains(event.target as HTMLElement)

      if (ref.current == null || isTargetHasEvent) return
      // outside click
      if (awayCallback) awayCallback(event)
    },
    [ref, awayCallback]
  )

  useEffect(() => {
    if (state) {
      document.addEventListener('click', handleClickOutside)
    } else {
      document.removeEventListener('click', handleClickOutside)
    }

    return () => {
      document.removeEventListener('click', handleClickOutside)
    }
  }, [state, handleClickOutside])
}
